import LeftBackgroundSvg from '@assets/confirmation_screen/left.svg'
import MobileBackgroundSvg from '@assets/confirmation_screen/mobile.svg'
import RightBackgroundSvg from '@assets/confirmation_screen/right.svg'
import ImageLogo from '@assets/logo.svg'
import { PasswordChangedMessage } from '@components/molecules/PasswordChangedMessage'
import { useNavigate } from 'react-router-dom'
import * as S from '../AccountConfirmation/AccountConfirmation.styles'

export interface SignupProps {
  testId?: string
}

export const PasswordChangedConfirmation = ({
  testId = 'component-checkemail-id'
}: SignupProps) => {
  const navigate = useNavigate()

  const _handleSignInRedirection = () => {
    navigate('/users/sign-in', { replace: true })
  }

  return (
    <S.Container data-testid={testId}>
      <S.GradientBackground>
        <S.LogoWrapper>
          <S.LogoArea>
            <S.Logo src={ImageLogo} alt="Jombine's logo" />
          </S.LogoArea>
        </S.LogoWrapper>

        <S.MobileLogo src={ImageLogo} alt="Jombine's logo" />

        <S.LeftBackground
          src={LeftBackgroundSvg}
          alt="Background image with an arrow pointing downwards with an o"
        />
        <S.RightBackground
          src={RightBackgroundSvg}
          alt="Background image with an arrow pointing upwards with an x"
        />
        <S.MobileBackground
          src={MobileBackgroundSvg}
          alt="Mobile Background image with arrows"
        />
        <S.RoundedBox>
          <PasswordChangedMessage goToSignIn={_handleSignInRedirection} />
        </S.RoundedBox>
      </S.GradientBackground>
    </S.Container>
  )
}
